import { useApiClient } from '@eluve/api-client-provider';
import { OneTimeTooltip } from '@eluve/blocks';
import { Button, Icon, useToast } from '@eluve/components';
import {
  useAllSummaries,
  useAppointmentId,
  useSummary,
} from '@eluve/frontend-appointment-hooks';
import { useTenantIdFromParams } from '@eluve/session-helpers';

export const RollbackPreviousSummaryButton = () => {
  const toast = useToast();
  const allSummaries = useAllSummaries();
  const apiClient = useApiClient();
  const currentSummary = useSummary();
  const appointmentId = useAppointmentId();
  const tenantId = useTenantIdFromParams() ?? '';

  const summaries = allSummaries?.summaries ?? [];
  if (summaries.length < 2) {
    return null;
  }
  const currentLlmOutputId = currentSummary?.llmOutputId;
  const currentIndex = summaries.findIndex(
    (summary) => summary.summaryId === currentLlmOutputId,
  );

  const previousSummary = currentIndex > 0 ? summaries[currentIndex - 1] : null;

  if (!previousSummary) {
    return null;
  }

  return (
    <OneTimeTooltip
      title="Undo Changes"
      position="bottom"
      content="You can still go back to the previous version by tapping on the undo button."
    >
      <Button
        variant="outline"
        size="sm"
        onClick={async () => {
          const newLlmOutputIdResponse =
            await apiClient.humanOutputs.setPreviousHumanOutputAsDefault({
              params: {
                tenantId,
                appointmentId,
                humanOutputId: currentSummary!.humanOutputId!,
              },
            });
          if (newLlmOutputIdResponse.status !== 200) {
            toast.error('Failed to rollback to previous summary');
          }
          currentSummary.refetch();
        }}
      >
        <Icon name="Undo2" size="auto" />
        Undo
      </Button>
    </OneTimeTooltip>
  );
};
